import { IImageConfig, IMAGES_RESOLUTIONS, IMAGES_SCREENS_RESOLUTIONS } from "../../base/base";

// TODO - re calc aspectRatio for this image
export const General_Image: IImageConfig = {
  typeDescription: 'General_Image',
  aspectRatio: null,
  defaultResolution: IMAGES_RESOLUTIONS.lg,
  resolutions: IMAGES_SCREENS_RESOLUTIONS,
  pathAccepted: [],
};
